export const IntakeProgressDetailsTestIds = {
  REVIEW_BUTTON: 'progress-details.review-button',
};
